import { render, staticRenderFns } from "./CategoriesStore.vue?vue&type=template&id=4c91628c"
import script from "./CategoriesStore.vue?vue&type=script&lang=js"
export * from "./CategoriesStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports